import { ShelfLifeEntry } from './shelfLifeTypes';

export const meatEntries: ShelfLifeEntry[] = [
  { keywords: ['chicken', 'chicken breast', 'chicken thigh', 'chicken leg', 'chicken wing'], fridge: 2, freezer: 270 },
  { keywords: ['ground beef', 'ground turkey', 'ground pork', 'ground meat'], fridge: 2, freezer: 120 },
  { keywords: ['steak', 'beef steak', 'ribeye', 'sirloin', 'filet'], fridge: 4, freezer: 180 },
  { keywords: ['pork chop', 'pork loin', 'pork tenderloin'], fridge: 4, freezer: 180 },
  { keywords: ['bacon'], fridge: 7, freezer: 30 },
  { keywords: ['sausage', 'italian sausage', 'breakfast sausage'], fridge: 2, freezer: 60 },
  { keywords: ['ham', 'deli ham'], fridge: 5, freezer: 60 },
  { keywords: ['turkey', 'turkey breast'], fridge: 2, freezer: 270 },
  { keywords: ['lamb', 'lamb chop'], fridge: 4, freezer: 180 },
  { keywords: ['hot dog', 'hot dogs', 'frankfurter'], fridge: 7, freezer: 60 },
  { keywords: ['deli meat', 'lunch meat', 'cold cuts', 'salami', 'pepperoni'], fridge: 5, freezer: 60 },
  { keywords: ['fish', 'salmon', 'tilapia', 'cod', 'tuna steak', 'halibut', 'trout', 'mahi'], fridge: 2, freezer: 180 },
  { keywords: ['shrimp', 'prawns'], fridge: 2, freezer: 180 },
  { keywords: ['crab', 'lobster', 'scallop', 'clam', 'mussel', 'oyster'], fridge: 2, freezer: 90 },
];
